import React, { useEffect, useState } from "react";
import {
  ContactBlueIcon,
  DateRangeIcon,
  DropDownwhiteIcon,
  InputDropDown,
  SearchGrayIcon,
  UploadIcon,
} from "../common/Icon";
import { AllConatactsDropdownData, AllConatctData } from "../common/Helper";
import CancelDeleteModal from "../dashboard/CancelDeleteModal";
import { useStateProvider } from "../common/StateProvider";

import ColorPickerModal from "../common/ColorPickerModal";

const AllConatacts = () => {
  const {
    deleteModal,
    setDeleteModal,
    deletModalHeading,
    setdeletModalHeading,
  } = useStateProvider();

  const [filteredList, setFilteredList] = useState(AllConatctData);
  const [deleteItemIndex, setDeleteItemIndex] = useState(null);

  const opendeleteModal = (value, index) => {
    setDeleteModal(true);
    setdeletModalHeading(value.reconnectModeltext);
    setDeleteItemIndex(index);
  };

  const deleteCard = () => {
    if (deleteItemIndex !== null) {
      const updatedData = [...filteredList];
      updatedData.splice(deleteItemIndex, 1);
      setFilteredList(updatedData);
      setDeleteModal(false);
      setDeleteItemIndex(null);
    }
  };

  // DropDown
  const [showDropDown, setShowDropDown] = useState(false);
  const [valueSelect, setValueSelect] = useState("");

  const updatedLavel = (value) => {
    if (value === "All Levels") {
      setFilteredList(AllConatctData);
    } else {
      const Data = AllConatctData.filter((obj) => {
        return obj.reconnectLevelText === value;
      });
      setFilteredList(Data);
    }
  };

  const inputChangeHandler = (value) => {
    const Data = AllConatctData.filter((obj) => {
      return obj.reconnectTeamName.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredList(Data);
  };
  const selectHander = (value) => {
    setValueSelect(value);
    setShowDropDown(false);

    const Data = AllConatctData.filter((obj) => {
      return obj.reconnectLabelBtn === value;
    });
    setFilteredList(Data);
  };

  const [color, setColor] = useState("#000"); // Default color
  const [showColorModal, setShowColorModal] = useState(false); //Color Modal

  const changebackgroundColor = () => {
    const spanElement = document.getElementById("bg-color-change");
    if (spanElement) {
      spanElement.style.backgroundColor = color;
      setShowColorModal(true);
    }
  };

  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
  };

  useEffect(() => {
    if (showColorModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showColorModal]);

  return (
    <>
      <div className="bg-white rounded-[5px] overflow-x-auto w-full max-w-[640px] sm:max-w-full shadow-my_contacts_tabs_shadow">
        <div className="pt-5 px-2.5 flex justify-between items-center whitespace-nowrap w-[600px] sm:w-auto">
          <div className="flex border border-[#f2f2f2] rounded-[31px] py-[11px] px-[9px] max-w-[250px] 2xl:max-w-[300px] w-full">
            <SearchGrayIcon />
            <input
              onChange={(e) => inputChangeHandler(e.target.value)}
              className="outline-none border-none font-normal text-xs 3xl:text-sm placeholder:text-gray text-black pl-3 w-full"
              type="text"
              placeholder="Search Contacts"
            />
            <span>
              {/* <InputDropDown /> */}
            </span>
          </div>
          <div className="flex pl-3">
            <button className="flex items-center border border-primary group hover:bg-primary transition-all ease-in-out duration-300 rounded-[31px] p-[7.5px]">
              <UploadIcon />
              <p className="font-normal text-primary group-hover:text-white  text-xs 3xl:text-sm">
                Upload Contact List
              </p>
            </button>
            <button className="flex items-center border border-primary group hover:bg-primary transition-all ease-in-out duration-300 rounded-[31px] p-[7.5px] ml-2">
              <ContactBlueIcon />
              <p className="font-normal group-hover:text-white text-primary text-xs 3xl:text-sm pl-2">
                Add Contact
              </p>
            </button>
          </div>
        </div>
        <div className="flex px-2.5 items-center justify-between pt-6 whitespace-nowrap w-[600px] sm:w-auto pb-7">
          <div className="relative">
            <div
              onClick={() => setShowDropDown(!showDropDown)}
              className={` fixed inset-0 min-h-full z-[999]  bg-black opacity-10 ${
                showDropDown ? "w-[100%] " : "hidden"
              }`}></div>
            <div
              className=" bg-primary py-2 px-2.5 cursor-pointer flex items-center justify-between rounded-[4px] w-[126px] xl:w-[146px]"
              onClick={() => setShowDropDown(!showDropDown)}>
              <span className="text-white text-xs 3xl:text-sm font-normal">
                {`${valueSelect ? `${valueSelect}` : "All Contacts"}`}
              </span>
              <DropDownwhiteIcon />
            </div>
            {showDropDown ? (
              <>
                <div className=" bg-white border-4 border-[#ededfe] w-[156px] absolute mt-2 z-[9999]">
                  {AllConatactsDropdownData.map((obj, index) => (
                    <div className=" px-2.5" key={index}>
                      <div
                        onClick={() => {
                          selectHander(obj.filterValue);
                        }}
                        className={`flex justify-between items-center cursor-pointer py-2  border-b border-[#f4f4ff] ${obj.selectValueHidden} `}>
                        <p className="text-xs 3xl:text-sm font-semibold text-black w-full">
                          {obj.selectValue}
                        </p>
                        <span
                          id="bg-color-change"
                          className={`w-full max-w-[14px] h-[14px] rounded-full bg-transparent ${obj.bgColor}`}></span>
                      </div>
                      <div
                        onClick={changebackgroundColor}
                        className={` flex justify-between items-center cursor-pointer py-2 border-b border-[#f4f4ff] ${obj.selectCustomHidden} `}>
                        <p className="text-xs 3xl:text-sm font-semibold text-black  w-full">
                          {obj.selectCustom}
                        </p>
                        <img
                          src={obj.selectColorImg}
                          className={`w-full max-w-[15px] h-[15px] rounded-full bg-transparent ${obj.selectBgColor}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              ""
            )}
            <div className="absolute top-[0px] left-[150px] z-[99999]">
              {showColorModal && (
                <ColorPickerModal
                  handleColorChange={handleColorChange}
                  color={color}
                />
              )}
            </div>
            <div
              onClick={() => setShowColorModal(false)}
              className={` fixed inset-0 min-h-full z-[9999]  bg-black opacity-20 ${
                showColorModal ? "w-[100%] " : "hidden"
              }`}></div>
          </div>
          <div>
            <button
              onClick={() => updatedLavel("Level 1")}
              className="px-[15px] py-1.5 font-normal text-[10px] 3xl:text-xs text-black hover:text-white hover:bg-green border-[0.603px] border-green bg-[#ecfaed] rounded-[45px] transition-all duration-300 ease-in-out">
              Level 1
            </button>
            <button
              onClick={() => updatedLavel("Level 2")}
              className="px-[15px] py-1.5 font-normal text-[10px] 3xl:text-xs text-black ml-1 hover:text-white hover:bg-yellow border-[0.603px] border-yellow bg-[#fcf7d6] rounded-[45px] transition-all duration-300 ease-in-out">
              Level 2
            </button>
            <button
              onClick={() => updatedLavel("Level 3")}
              className="px-[15px] py-1.5 font-normal text-[10px] 3xl:text-xs text-black ml-1 hover:text-white hover:bg-skyblue border-[0.603px] border-skyblue bg-[#d1edfb] rounded-[45px] transition-all duration-300 ease-in-out">
              Level 3
            </button>
            <button
              onClick={() => updatedLavel("All Levels")}
              className="px-[15px] py-1.5 font-normal text-[10px] 3xl:text-xs text-white ml-1 hover:text-primary border-[0.603px] border-primary bg-primary hover:bg-transparent rounded-[45px] transition-all duration-300 ease-in-out">
              All Levels
            </button>
          </div>
        </div>
        <div className="w-[600px] sm:w-auto overflow-x-auto  lg:h-[calc(100vh-270px)] xl:h-[calc(100vh-275px)] 3xl:h-[calc(100vh-285px)] lg:overflow-y-auto overflow_x_scroll_style">
          {filteredList.map((value, index) => (
            <div
              className=" p-[7px_10px] mx-2.5 rounded-md bg-white hover:shadow-workflow_item_card_shadow duration-300 cursor-pointer my-[7px]"
              key={index}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <img src={value.reconnectImg} alt="teams" />
                  <div>
                    <div className=" flex items-center gap-4">
                      <h5 className="text-sm 3xl:text-base font-normal text-black">
                        {value.reconnectTeamName}
                      </h5>
                      <div className="flex gap-1 items-center">
                        <span>{value.reconnectStatusIcon}</span>
                        <p
                          className={`${value.reconnectLevelTextColor} text-xs 3xl:text-sm font-normal`}>
                          {value.reconnectLevelText}
                        </p>
                      </div>
                      <div className=" flex items-center gap-1">
                        <span>
                          <DateRangeIcon />
                        </span>
                        <p className="text-[10px] 3xl:text-xs font-normal text-gray">
                          {value.reconnectFullDate}
                        </p>
                      </div>
                      <p
                        className={` ${value.reconnectLabelBtnBgColor} text-[8px] 3xl:text-[10px] font-bold text-white p-[4px_10px] rounded-[38px] `}>
                        {value.reconnectLabelBtn}
                      </p>
                    </div>
                  </div>
                </div>
                <div className=" flex items-center gap-[6px]">
                  <span onClick={() => opendeleteModal(value, index)}>
                    {value.deleteWorkflowIcon}
                  </span>
                  <span>{value.rightArrow}</span>
                </div>
              </div>
            </div>
          ))}
          {/* DELETE MODAL HEADING */}
          {deleteModal && (
            <CancelDeleteModal
              deleteModal={deleteModal}
              setDeleteModal={setDeleteModal}
              deletModalHeading={deletModalHeading}
              deleteCard={deleteCard}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AllConatacts;
